export default "<app-nav></app-nav>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"